// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ox0y","footer":"styles_footer__1cVfw","passCodeTooltip":"styles_passCodeTooltip__2kMPx"};